<template>
  <material-card>
    <v-layout slot="header" px-3>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Kontenery na punkty</div>

        <p>Lista kontenerów utworzonych przez Partnera</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex text-xs-right>
        <check-permission permissions="POINT_CONTAINER.ADD" entity-type="partner" :entity-id="partnerId">
          <v-btn large color="error" @click="showAddModal">Dodaj kontener</v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <material-table
      entity-type="POINT_CONTAINER"
      :headers="table.headers"
      :actions="actions"
      :items="list"
      :total-count="count"
      @edit="showEditModal($event.id)"
      @delete="remove($event.id)"
      @manageBenefits="manageBenefits($event.id)"
    />

    <add-container :id="idToEdit" :show="showModal" @close="hideModal" @update="update" @save="add" />

    <manage-container-benefits
      :point-container-id="pointContainerId"
      :show="showManageModal"
      @close="hideManageModal"
    />
  </material-card>
</template>

<script>
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import AddContainer from './modals/AddContainer.modal';
import ManageContainerBenefits from './modals/ManageContainerBenefits.modal';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania listy kontenerów.',
  getError: 'Wystąpił błąd podczas pobierania danych kontenera.',
  added: 'Dodano kontener.',
  addError: 'Nie udało się dodać kontenera.',
  updated: 'Zaktualizowano dane kontenera.',
  updateError: 'Nie udało się zaktualizować danych kontenera.',
  deleted: 'Usunięto kontener.',
  deleteError: 'Nie udało się usunąć kontenera.'
};

// @vuese
// Kontenery partnera
// @group Tabs
export default {
  components: { MaterialCard, AddContainer, MaterialTable, ManageContainerBenefits },

  mixins: [listMixin('partners/pointContainers', messages)],
  data() {
    return {
      table: {
        headers: [
          { value: 'id', text: 'ID', sortable: true },
          { value: 'name', text: 'Nazwa', sortable: true }
        ]
      },
      showManageModal: false,
      pointContainerId: null
    };
  },
  computed: {
    ...mapState({
      partnerId: state => state.partners.id,
      list: state => state.partners.pointContainers.list,
      count: state => state.partners.pointContainers.count
    }),
    actions() {
      return [
        { ...EDIT_ACTION, entityType: 'partner', entityId: this.partnerId },
        { ...DELETE_ACTION, entityType: 'partner', entityId: this.partnerId },
        { icon: 'mdi-format-list-numbered-rtl', event: 'manageBenefits', permissionTypes: [] }
      ];
    }
  },
  methods: {
    // @vuese
    // Otworzenie modala zarządzania przypisaniami
    manageBenefits(id) {
      this.$store.dispatch('partners/containerBenefit/list', { count: -1, pointContainerId: id }).then(() => {
        this.pointContainerId = id;
        this.showManageModal = true;
      });
    },
    // @vuese
    // Zamknięcie modala zarządzania przypisaniami
    hideManageModal() {
      this.showManageModal = false;
      this.pointContainerId = null;
    },
    filters(pagination, route) {
      return { ...pagination, partnerId: parseInt(route.params.id) };
    }
  }
};
</script>
